<template lang="pug">
.guide-view
  //- 960
  .guide-wrapper.d-flex
    .guide-box-1
      .guide-content.text-align-center
        .banner-close-button(@click="closeWindow") X
        .banner-img
          img(:src="img")
</template>
<script>
export default {
  name: 'BigBannerView',
  props: ['img'],
  components: {
  },
  computed: {
  },
  created () {
  },
  data () {
    return {
      closeGuide () {
        this.$root.isGuide = false
      }
    };
  },
  methods: {
    closeWindow () {
      this.$emit('closeWindow')
    }
  }
}
</script>

<style lang="sass" scoped>
.guide-wrapper
  position: fixed
  left: 0
  right: 0
  top: 0
  bottom: 0
  width: 100%
  height: 100%
  z-index: 99
  // display: flex
  flex-flow: row nowrap
  justify-content: center
  align-items: center
  align-content: center
  background-color: rgba(0, 0, 0, 0.6)
  .guide-box-1
    max-width: 500px
    max-height: 700px
    // overflow: hidden
    overflow-y: scroll
    width: 80%
    position: relative
    // display: flex
    // flex-flow: row nowrap
    // justify-content: center
    // align-items: center
    // align-content: center
    background: #ffffff
    margin: 0 auto 0 auto
    border-radius: 15px
    padding: 1.5rem 1.2rem
    .guide-content
      width: 100%
      height: 100%
      .banner-close-button
        position: absolute
        right: 10px
        top: 10px
        background: #fff
        padding: 7px 15px
        border-radius: 100%
        border: 1px solid #000
        cursor: pointer
      .logo-img
        width: 5rem
        margin: 1rem calc(50% - 2.5rem)
      .guide-text-group
        color: #2e50ff
        font-size: 1rem
        font-weight: 500
        margin: 1.5rem 0
      .guide-hand-img
        width: 13rem
        margin: 1rem auto 2rem auto
      .guide-button-group
        bottom: 4%
        margin-top: 1%
        position: relative
        .guide-button-1
          min-width: 10vmin
          font-size: 1rem
          padding: .8rem 1rem
        .guide-button-2
          margin-top: .5rem
          min-width: 10vmin
          font-size: 1rem
          padding: .8rem 1rem
          background: none
          color: #91949c
          text-decoration-line: underline

  .guide-box-2
    min-width: 300px
    width: 90%
    position: relative
    .guide-content
      width: 100%
      height: 100%
      position: absolute
      left: 0
      top: 0
      padding: 1rem
      text-align: centers
      .title-text
        margin-top: 5%
        line-height: 2rem
        color: #2e50ff
        font-size: 1.2rem
        font-weight: 500
      .logo-img
        margin-left: 10%
        width: 80%
      .guide-text-group
        color: #2e50ff
        font-size: .9rem
        font-weight: 500
        margin-top: 5%
      .guide-hand-img
        width: 70%
        margin-top: 5%
      .guide-button-group
        top: 3%
        margin-top: 1%
        position: relative
        .guide-button-1
          min-width: 10vmin
          font-size: .8rem
          padding: .8rem 1rem
        .guide-button-2
          min-width: 10vmin
          font-size: .8rem
          padding: .8rem 1rem
          background: none
          color: #91949c
          text-decoration-line: underline
.mr-15
  margin-right: 15px
</style>
